import { useQuery } from "@tanstack/react-query";
import { PagedResponse } from "src/utils/types";
import { axiosCompanyInstance } from "src/config/axios";
import { CustomerListModel } from "../types/Customer";
import { removeEmptyKeysFromFilters } from "src/utils/object";

export const RQ_CUSTOMER_LIST_KEY = "CUSTOMER_LIST_KEY";

export type CustomerListResponse = PagedResponse<CustomerListModel[]>;

export type CustomerListFilters = {
    id?: string;
    name?: string;
    email?: string;
    vatId?: string;
    customerGroupId?: string;
};

export const useCustomerList = (
    page: number,
    perPage: number,
    searchFilters: CustomerListFilters
) => {
    const filters = removeEmptyKeysFromFilters(searchFilters);

    return useQuery({
        queryKey: [RQ_CUSTOMER_LIST_KEY, page, perPage, filters],
        queryFn: async (): Promise<CustomerListResponse | null> => {
            const res = await axiosCompanyInstance.get(`customer`, {
                params: { ...filters, page: page + 1, perPage },
            });

            return res?.data || null;
        },
    });
};
